<template>
  <component
    :is="tag"
    class="layout-grid">
    <slot />
  </component>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults( defineProps<{
  minimum?: string | number;
  spacing?: string;
  repeatCount?: number | "auto-fit" | "auto-fill";
  tag?: string;
}>(), {
  minimum: "250px",
  spacing: "var(--s-3)",
  repeatCount: "auto-fill",
  tag: "div",
} );

const formattedMinimum = computed( () => {
  if ( typeof props.minimum === "number" ) {
    return `${props.minimum}px`;
  }

  return props.minimum;
} );
</script>

<style lang="scss" scoped>
.layout-grid {
  display: grid;
  grid-gap: v-bind(spacing);
  grid-template-columns: repeat(v-bind(repeatCount), minmax(v-bind(formattedMinimum), 1fr));
}

@supports (width: min(v-bind(formattedMinimum), 100%)) {
  .layout-grid {
    grid-template-columns: repeat(v-bind(repeatCount), minmax(min(v-bind(formattedMinimum), 100%), auto));
  }
}
</style>
